import { buildContractPath } from "./api/contract-client.js";

export const AUTOMATION_TIMEOUT_MS = 20000;

export function buildGetAutomationsPath() {
  return buildContractPath("get__automations");
}

export function buildPostAutomationsPath() {
  return buildContractPath("post__automations");
}

export function buildPostAutomationTriggerPath(automationId) {
  return buildContractPath("post__automations_p_trigger", { pathParams: [automationId] });
}

export function buildGetAutomationRunsPath(automationId) {
  return buildContractPath("get__automations_p_runs", { pathParams: [automationId] });
}
